import React, { useState } from "react";
import { FiAlertCircle } from "react-icons/fi";
import styles from "./styles.module.css";
import { doesUserExist, storeLoginToken } from "../../database/login";
import { userDoesNotExistWarning } from "../../toasts/login";
import { toast } from "react-toastify";
import { BrandLogo, Button } from "../../components/UI";
export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sentTo, setSentTo] = useState<string | null>(null);
  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    try {
      const exists = await doesUserExist(email);
      if (!exists) {
        userDoesNotExistWarning();
        return;
      }
      const token = await storeLoginToken(email);
      if (!token) {
        toast.error("Error generating login link, please try again later.");
        return;
      }
      const response = await fetch(
        "https://d88ja061rl.execute-api.us-east-1.amazonaws.com/prod/sendMail",
        {
          method: "POST",
          body: JSON.stringify({
            email,
            subject: "Robotical - Login Link",
            queryString: token.queryString,
          }),
          headers: { "Content-Type": "application/json" },
        },
      );
      if (response.status === 200) {
        setSentTo(email);
        toast.success("Email sent successfully! Please check your inbox.");
      } else toast.error("Error sending email, please try again later.");
    } catch (error) {
      toast.error("Could not send the login link. Please try again.");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <main className={styles.container}>
      <section className={styles.card} aria-labelledby="login-heading">
        <BrandLogo className={styles.logo} />
        <div className={styles.heading}>
          <h1 id="login-heading">{sentTo ? "Check your email" : "Sign in"}</h1>
          <p>
            {sentTo
              ? "Login link sent to"
              : "Use the email registered with your robots."}
          </p>
        </div>
        {sentTo ? (
          <>
            <strong className={styles.address}>{sentTo}</strong>
            <p className={styles.note}>
              Open the link in your inbox to continue.
            </p>
            <Button
              className={styles.fullWidth}
              onClick={() => setSentTo(null)}
            >
              Use a different email
            </Button>
          </>
        ) : (
          <form onSubmit={handleLogin} className={styles.form}>
            {window.location.search && (
              <p className={styles.warning} role="status">
                <FiAlertCircle aria-hidden="true" />
                <span>This link is no longer valid. Request a new one.</span>
              </p>
            )}
            <div className={styles.field}>
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                placeholder="teacher@school.org"
                required
                disabled={isLoading}
              />
            </div>
            <Button
              type="submit"
              variant="primary"
              className={styles.fullWidth}
              disabled={isLoading}
              aria-busy={isLoading}
            >
              {isLoading ? "Sending login link…" : "Send login link"}
            </Button>
          </form>
        )}
      </section>
    </main>
  );
}
